export default __webpack_public_path__ + "static/media/contact.8c565c55.svg";